import React from "react";
import virus1 from "../../../Assets/Home/Common/virus1.png";
import virus2 from "../../../Assets/Home/Common/virus2.png";
import virus3 from "../../../Assets/Home/Common/virus3.png";
import virus4 from "../../../Assets/Home/Common/virus4.png";
import lab1 from "../../../Assets/Home/Lab/lab1.png";
import lab2 from "../../../Assets/Home/Lab/lab2.png";
import lab3 from "../../../Assets/Home/Lab/lab3.png";
import lab4 from "../../../Assets/Home/Lab/lab4.png";
import { FaArrowRightLong } from "react-icons/fa6";

const Mission = () => {
  const sections = [
    {
      title: "Vision", desc: "To be India’s leading diagnostic partner, delivering precision, innovation, and trust in every test while making healthcare accessible to every community, including remote areas.", icon: <img src={lab1} alt="icon" />
    },
    {
      title: "Mission", desc: "Our mission is to deliver world-class diagnostics crafted with care, accessible to all sections of society, reaching even the remotest corners of India.", icon: <img src={lab2} alt="icon" />
    },
    // { title: "Pharmaceutical", desc: "Accuracy of microbiological quality control tests.", icon: <img src={lab3} alt="icon" /> },
    // { title: "Biochemistry", desc: "Diagnosis of diseases and the determination of treatment.", icon: <img src={lab4} alt="icon" /> },
  ];

  return (
    <div className="bg-[#fafafa] ">
      {/* Main Section */}
      <div className="relative pt-20 xl:px-28 md:px-10 px-6">
        <img src={virus4} alt="decor" className="absolute top-10 left-20 w-16 h-16 animate-bounce-down pointer-events-none" />
        <img src={virus2} alt="decor" className="absolute bottom-20 right-10 w-16 h-16 animate-bounce-up pointer-events-none" />
        <img src={virus1} alt="decor" className="absolute top-10 right-10 w-16 h-16 animate-bounce-left pointer-events-none" />
        <img src={virus3} alt="decor" className="absolute bottom-10 left-10 w-16 h-16 animate-bounce-right pointer-events-none" />

        {/* Lab Cards */}
        <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
          {sections.map((section, index) => (
            <div data-aos="flip-down"
              key={index}
              className="lab-card bg-white rounded-xl shadow-lg px-4 sm:px-6 md:px-10 py-4 sm:py-6 flex flex-col items-start hover:shadow-2xl  transition-all duration-300 ease-in-out"
            >
              <div className="my-6 card-icon">{section.icon}</div>
              <h3 className="text-2xl font-semibold familjen-font my-2 card-title">{section.title}</h3>
              <p className="text-sm md:text-[1rem] font-normal leading-relaxed text-[#5a5a5a] my-6 card-desc">{section.desc}</p>
              {/* <button className="font-semibold flex items-center gap-2 mb-6 card-button">
                READ MORE <FaArrowRightLong />
              </button> */}
            </div>
          ))}
        </div>
      </div>

      <div className="marquee-container py-6" >
        <div data-aos="fade-up" data-aos-duration="700" className="marquee-content">
          <span className="uppercase text-[3rem] md:text-[6rem] lg:text-[8rem] font-bold tracking-widest text-gray-800 px-8">
            <span className="text-primaryColor pl-4">Diagnostic</span> Science <span className="text-primaryColor pr-20">Laboratory</span>
          </span>
          <span className="uppercase text-[3rem] md:text-[6rem] lg:text-[8rem] font-bold tracking-widest text-gray-800 px-8">
            <span className="text-primaryColor">Diagnostic</span> Science <span className="text-primaryColor">Laboratory</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Mission;